import { useRef, useState, useEffect, useContext, createContext } from 'react';
import { useLocation, Link, useNavigate } from "react-router-dom";

import { Container, Stack, Button, TextField } from '@mui/material';

import axios from "axios";
import dayjs from 'dayjs';

import { API, MSG } from "./constantsFront";
import { MsgContext } from '../../App';

/**
 * 質問カテゴリ編集
 * @returns
 */

const G0223QuestionCategoryEdit = () => {
  const [PublishDate, setPublishDate] = useState("");
  const [QuestionCategoryId, setQuestionCategoryID] = useState("");       //質問カテゴリーID
  const [QuestionCategoryName, setQuestionCategoryName] = useState("");   //質問カテゴリー名
  const [QuestionCategoryOrder, setQuestionCategoryOrder] = useState(""); //質問表示順

  const [PublishDateMsg, setPublishDateMsg] = useState("");
  const [queCateIdMsg, setQueCateIdMsg] = useState("");     //必須チェック用メッセージ(質問カテゴリーID)
  const [queCateNameMsg, setQueCateNameMsg] = useState(""); //必須チェック用メッセージ(質問カテゴリー名)
  const [queCateDispMsg, setQueCateDispMsg] = useState(""); //必須チェック用メッセージ(表示順)
  const [QueCateMain, setQueCateMain] = useState("");       //Edit画面表題

  const { msg, setMsg } = useContext(MsgContext); //エラーメッセージ
  const navigate = useNavigate();
  let body = { authKey: API.API_KEY }

  let select_qcl_id = '';                         //操作内容(新規追加(値:-1)、変更(値:選択された質問カテゴリーID))を判定するid

  //G0222のstateからデータを受け取る
  const location = useLocation();
  if (location.state != null) {
    select_qcl_id = location.state.ID;
    //ローカルストレージに保存する
    window.localStorage.setItem("select_qcl_id", select_qcl_id);
  } else {
    //ローカルストレージから取り出す
    select_qcl_id = window.localStorage.getItem("select_qcl_id");
  }

  //初回読込チェック
  const refIsFirst = useRef(true);              //useEffect初回読込フラグ
  useEffect(() => {
    if (!refIsFirst.current) {
      return;
    }
    //新規追加・編集による分岐
    if (select_qcl_id == -1) {
      setQueCateMain("質問カテゴリー新規追加");
    } else {
      getQuestionCategory();
      setQueCateMain("質問カテゴリー編集");
    }
    //初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])


  //質問カテゴリー取得
  async function getQuestionCategory() {
    try {
      body.categoryid = select_qcl_id;
      let res = await axios.post("/m_que_category/select/auth", body)
      if (res.status !== 200) {								        //データ取得エラー
        return;
      } else {																				//正常時
        let QCList = res.data.categoryList
        setQuestionCategoryID(QCList[0].category_id);
        setQuestionCategoryName(QCList[0].category_name);
        setQuestionCategoryOrder(QCList[0].display_order);
        setPublishDate(QCList[0].publish_date ? dayjs(QCList[0].publish_date).format('YYYY-MM-DD HH:mm:ss') : null)
      }
    } catch (err) {
      console.log('error:', err.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  //保存処理
  async function register() {
    try {
      console.log('保存処理開始');

      //入力値チェックと代入処理
      let csletr = {}
      if (!PublishDate) {
        setPublishDateMsg("公開日時は必須です。");
      } else {
        setPublishDateMsg("");
        csletr.publish_date = PublishDate;
      }

      if (select_qcl_id != -1) {                        //質問カテゴリーIDチェック
        if (!QuestionCategoryId) {                        //編集時チェック
          setQueCateIdMsg("質問カテゴリーIDは必須です");
        } else {
          setQueCateIdMsg("");
          csletr.category_id = QuestionCategoryId;
        }
      } else {
        setQueCateIdMsg("");                              //新規追加時
      }

      if (!QuestionCategoryName.trim()) {                      //質問カテゴリー名チェック
        setQueCateNameMsg("質問カテゴリー名は必須です");
      } else {
        setQueCateNameMsg("");
        csletr.category_name = QuestionCategoryName.trim()
      }

      if (!QuestionCategoryOrder) {                     //表示順チェック-未入力時
        setQueCateDispMsg("");
        csletr.display_order = null;
      } else {                                          //表示順チェック-入力時
        if (!String(QuestionCategoryOrder).match(/^[+-]?([1-9][0-9]*|0)$/)) {
          setQueCateDispMsg("整数を入力してください。")
          return
        } else {
          setQueCateDispMsg("");
          csletr.display_order = QuestionCategoryOrder
        }
      }

      if ((select_qcl_id != -1 & !QuestionCategoryId) || !QuestionCategoryName.trim() || !PublishDate) { //必須入力値チェック
        return;
      }

      //追加・変更内容をbodyへ格納する処理
      let arrStr = [];
      arrStr = JSON.stringify(csletr);
      body.arrStr = arrStr;

      // insert・update処理の分岐と実行
      if (select_qcl_id == -1) {
        // insert
        const res = await axios.post("/m_que_category/insert/auth", body);
        if (res.status !== 200) {                                           //失敗時
          console.log('保存処理終了(insert失敗)');
          setMsg("新規追加が失敗しました。もう一度入力してください。");
          return;
        } else {                                                            //成功時
          console.log('保存処理終了(insert成功)');
        }
      } else {
        // update
        const res = await axios.post("/m_que_category/update/auth", body);
        if (res.status !== 200) {                                           //失敗時
          console.log('保存処理終了(update失敗)');
          setMsg("編集が失敗しました。もう一度入力してください。");
          return;
        } else {                                                            //成功時
          console.log('保存処理終了(update成功)');
        }
      }
      return window.location.href = './G0222QuestionCategoryList';
    } catch (e) {
      console.log("保存処理終了(例外発生)");
      console.log('error:', e.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">
              <Container maxWidth="lg">
                <Stack spacing={2}>
                  <h1>{QueCateMain}</h1>

                  <TextField required id="publish_date"
                    value={PublishDate ?? ''}
                    label="公開日時"
                    type={"datetime-local"}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    helperText={PublishDateMsg}
                    error={Boolean(PublishDateMsg == "" ? false : true)}
                    onChange={e => { setPublishDate(e.target.value) }}
                  />

                  {select_qcl_id !== -1 ? (
                    <TextField id="category_id"
                      value={QuestionCategoryId ?? ''}
                      label="質問カテゴリーID"
                      error={Boolean(queCateIdMsg == "" ? false : true)}
                      helperText={queCateIdMsg}
                      onChange={e => { setQuestionCategoryID(e.target.value) }}
                      disabled={true}
                    />
                  ) : (null)}


                  <TextField required id="category_name"
                    value={QuestionCategoryName ?? ''}
                    label="質問カテゴリー名"
                    error={Boolean(queCateNameMsg == "" ? false : true)}
                    helperText={queCateNameMsg}
                    onChange={e => { setQuestionCategoryName(e.target.value) }}
                  />

                  <TextField id="display_order"
                    value={QuestionCategoryOrder ?? ''}
                    label="表示順"
                    error={Boolean(queCateDispMsg == "" ? false : true)}
                    helperText={queCateDispMsg}
                    onChange={(e) => {
                      if (e.target.value.length <= 9) {
                        setQuestionCategoryOrder(e.target.value)
                      }
                    }}
                    maxLength={9}
                  />

                  <Stack spacing={2} direction="row">
                    <Button component={Link} to={"/G0222QuestionCategoryList"}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      戻る
                    </Button>

                    <Button onClick={register}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      保存
                    </Button>
                  </Stack>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default G0223QuestionCategoryEdit;